import { useState } from 'react'
import { mutate } from 'swr'
import { Update_Book_Archive_Status } from '@graphql/mutations'
import {
  Single_Book,
  Single_SchoolClass,
  Single_SchoolGroup,
  Single_Section,
} from '@graphql/queries'
import { useApi } from '@hooks/useApi'
import { useContext } from 'react'
import { AppContext } from '@state/context'
import { SCHOOL_RESOURCE_TYPES } from '@helpers/constants'

const useUpdateBookArchiveStatus = () => {
  const [state, dispatch] = useContext(AppContext)
  const {
    app: { currentSection, currentEditBookObject },
  } = state

  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    const { resourceType, resourceId, pivotId, isArchived } = data

    let pivotTable = null

    if (resourceType === SCHOOL_RESOURCE_TYPES.CLASS) {
      pivotTable = 'book_school_class'
    }
    if (resourceType === SCHOOL_RESOURCE_TYPES.GROUP) {
      pivotTable = 'book_school_group'
    }

    if (!pivotTable) return false

    setIsPosting(true)

    const res = await postMutation(
      { pivotTable: pivotTable, pivotId: pivotId, isArchived: isArchived },
      Update_Book_Archive_Status,
      successMessage
        ? successMessage
        : isArchived
        ? 'Bok arkiverad.'
        : 'Bok avarkiverad.',
      errorMessage ? errorMessage : 'Nåt gick fel.',
      async () => {
        if (resourceType === SCHOOL_RESOURCE_TYPES.CLASS) {
          await mutate([Single_SchoolClass, resourceId])
        }

        if (resourceType === SCHOOL_RESOURCE_TYPES.GROUP) {
          await mutate([Single_SchoolGroup, resourceId])
        }
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpdateBookArchiveStatus }
